import axios from 'axios'

import CSRF from '@/services/csrf'
import store from '@/vuex/store'
import { camelToSnake, snakeToCamel } from '../../utils/object'

const getApiClient = () => store.getters.apiClient

export default {
  // Store Helpers: Interface methods to help decouple API functions from Vuex.
  getApiClient,
  get apiClient() {
    return this.getApiClient()
  },
  // auth
  sendEmail,
  resetPassword,
}

// Send user's email to get reset link
function sendEmail(email) {
  const endpoint = 'password/reset/'
  const promise = axios.post(endpoint, { email }, { headers: CSRF.getHeaders() })
  return promise
    .then(response => {
      return snakeToCamel(response)
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log('Send email API error')
      throw error
    })
}

// Send user's id, token and new password to reset previous password
function resetPassword(uid, token, password) {
  const endpoint = `password/reset/confirm/${uid}/${token}/`
  const promise = axios.post(endpoint, {
    new_password1: password,
    new_password2: password,
  })
  return promise
    .then(response => {
      return snakeToCamel(response)
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log('Login API error')
      throw error
    })
}
